// @ts-check
import Icon from './base/Icon';
import { noop } from 'lodash';
import { LBButton } from '@linearb/buzz';

const HelpIcon = ({ onClick = noop, size = 'smaller', ...rest }) => {
  return (
    <LBButton size='icon' variant='ghost' onClick={onClick}>
      <Icon name='helpicon' size={size} color='chambray' {...rest} />
    </LBButton>
  );
};

export default HelpIcon;
